firebird.factory('videoFeatureFlagsService', [
    '$timeout',
    '$window',
    '$rootScope',
    'logService',
    'attendeeService',
    'attendeeListService',
    'connectivityService',
    'socketService',
    'helperService',
    'analyticsWrapperService',
    'notificationService',
    'meetingService',
    'configService',
    'videoLayoutAlgorithmService',
    'videoGlobalService',
    'localizationService',
    function (
        $timeout,
        $window,
        $rootScope,
        logService,
        attendeeService,
        attendeeListService,
        connectivityService,
        socketService,
        helperService,
        analyticsWrapperService,
        notificationService,
        meetingService,
        configService,
        videoLayoutAlgorithmService,
        videoGlobalService,
        localizationService
    ) {
        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoFeatureFlagsService');

        let audioRecordTimer;

        var service = {
            initialize: initialize
        };

        var self, $scope;

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // when advanced settings is updated while in an active call.
            $scope.$on('advanced-settings-changed', onAdvancedSettingsChanged);
            $rootScope.$on('meeting-state-v2', onMeetingStateV2);
            // feature flags (labs playground) related code. process events from featureFlagsCtrl.js
            self.initFeatureFlags = initFeatureFlags;
            self.parseFeatureFlagsParams = parseFeatureFlagsParams;
            self.onFeatureFlagsRequest = onFeatureFlagsRequest;
            self.onFeatureFlagsRequestInternal = onFeatureFlagsRequestInternal;
            self.onFeatureFlagsRequestInternalAlt = onFeatureFlagsRequestInternalAlt;
            self.featureFlagsClickAction = null;
            self.onFeatureFlagsClickAction = onFeatureFlagsClickAction;
            self.featureFlagsClickActionAlt = null;
            self.onFeatureFlagsClickActionAlt = onFeatureFlagsClickActionAlt;
            self.onStartResizeLayout = onStartResizeLayout;
            self.onShowVideoFromSfu = onShowVideoFromSfu;
            self.onShowVideoFromMcu = onShowVideoFromMcu;
            self.onDoIceRestartAudio = onDoIceRestartAudio;
            self.onDoAudioMuteUnmute = onDoAudioMuteUnmute;
            self.onDoIceRestart = onDoIceRestart;
            self.onRequestKeyFrame = onRequestKeyFrame;
            self.onSelectSubstream = onSelectSubstream;
            self.onRestartVideoPlay = onRestartVideoPlay;
            self.onRestartVideoPublish = onRestartVideoPublish;
            self.onDoReconnectMTG = onDoReconnectMTG;
            self.onDoReconnectSIP = onDoReconnectSIP;
            self.onDoReconnectWS = onDoReconnectWS;
            self.onDoReconnectOtherSIP = onDoReconnectOtherSIP;
            self.onDoReconnectOtherWS = onDoReconnectOtherWS;
            self.onForceAudioMuted = onForceAudioMuted;
            self.onForceVideoMuted = onForceVideoMuted;
            self.onSetLoggingAudiojb = onSetLoggingAudiojb;
            self.onRecordAudioAll = onRecordAudioAll;
            self.onCopyNotesToClipboard = onCopyNotesToClipboard;

            // whether to display video received from MCU.
            self.videoFromMcu = null;

            // whether to hide sidebar on join.
            self.hideSideBar = false;

            self.loggingAudioJb = {};

            self.onToggleSpotlightInRecord = onToggleSpotlightInRecord;

            $scope.$on('feature-flags-request', self.onFeatureFlagsRequest);
        }

        // update other state from config
        function initFeatureFlags() {
            // hide sidebar on join
            self.hideSideBar = configService.getClientValue('hideSideBar') == 'true';
        }

        // show labs tab if featureFlags URL param present. and search filter if has value other than true.
        function parseFeatureFlagsParams() {
            var featureFlagsValue = helperService.getQueryParameter('featureFlags');
            if (featureFlagsValue && featureFlagsValue != 'false') {
                $rootScope.$broadcast('showhide-feature-flags');
                if (featureFlagsValue != 'true') {
                    $timeout(function () {
                        $window.$('#feature-flags #show-search-all').click();
                        $window.$('#feature-flags-search').val(featureFlagsValue);
                        $window.$('#feature-flags-search').trigger('keyup');
                    }, 2000);
                }
            }
        }

        // when settings is update, need to rejoin the call.
        function onAdvancedSettingsChanged(e, data) {
            if (data && data.length == 1 && data[0] == 'layoutLock') {
                // no need to re-join the call for layout change.
                logService.log('videoroomCtrl - updating layoutLock');
                self.setLayoutLock(true);
                self.updateVideosLayout();
            } else {
                logService.log('videoroomCtrl - rejoining conference due to change in settings');
                self.applyQueryParameters();
                self.rejoinConferenceIfNeeded('settings');
            }
        }

        // when a request is sent from the feature-flags dialog.
        function onFeatureFlagsRequest(e, data) {
            logService.log('videoroomCtrl - feature-flags-request received ' + JSON.stringify(data));

            var featureFlags = { sfuEvent: true };
            for (var attr in data) {
                featureFlags[attr] = data[attr];
            }
            analyticsWrapperService.eventTrack('Meeting - feature-flags - request', featureFlags);
            self.msgflowEvent('feature request', data);

            self.onFeatureFlagsRequestInternal(data);
        }

        function onFeatureFlagsRequestInternal(data) {
            if (data.type == 'start-resize-layout') {
                self.onStartResizeLayout();
            } else if (data.type == 'show-video-from-sfu') {
                self.onShowVideoFromSfu();
            } else if (data.type == 'show-video-from-mcu') {
                self.onShowVideoFromMcu();
            } else if (
                [
                    'do-ice-restart',
                    'request-keyframe',
                    'select-substream',
                    'restart-video-play',
                    'restart-video-publish',
                    'showhide-one-video',
                    'toggle-spotlight-in-record',
                    'toggle-layout-pin',
                    'layout-page-flip-selected',
                    'test-layout-remove-selected'
                ].indexOf(data.type) >= 0
            ) {
                if ($window.$('#videoroom-videos > div[enable="true"]:not(.audioonly)').length > 0) {
                    self.featureFlagsClickAction = data.type;
                    $window.$('#videoroom-videos').attr('has-click-action', 'true');
                    $window.$('#localSfuScreenShareFeedContainer').attr('has-click-action', 'true');
                    $window.$('#localSfuScreenShareFeedContainer').click(function (event) {
                        self.onFeatureFlagsClickAction(undefined, true);
                    });
                } else {
                    logService.log('videoroomCtrl - feature-flags-request no videos shown, so ignoring ' + data.type);
                }
            } else if (
                ['do-reconnect-sip-other', 'do-reconnect-ws-other', 'set-logging-audiojb-other'].indexOf(data.type) >= 0
            ) {
                if ($window.$('ul#attendee-list').length > 0) {
                    self.featureFlagsClickActionAlt = data.type;
                    logService.log('videoroomCtrl listening for click on attendee list items');
                    $window.$('ul#attendee-list').attr('has-click-action', 'true');
                    var clickActionTimer = $timeout(function () {
                        logService.log('videoroomCtrl removing click listener after timeout.');
                        clickActionTimer = null;
                        self.featureFlagsClickActionAlt = null;
                        $window.$('ul#attendee-list').removeAttr('has-click-action');
                        $window.$('ul#attendee-list > li.attendee-obj').unbind('click');
                    }, 20000); // cleanup after 20s of no click.
                    $window.$('ul#attendee-list > li.attendee-obj').click(function (event) {
                        logService.log(
                            'videoroomCtrl click detected on ' +
                                ((event.currentTarget && event.currentTarget.id) || 'null')
                        );
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        $window.$('ul#attendee-list').removeAttr('has-click-action');
                        $window.$('ul#attendee-list > li.attendee-obj').unbind('click');
                        if (clickActionTimer) {
                            $timeout.cancel(clickActionTimer);
                            clickActionTimer = null;
                        }
                        self.onFeatureFlagsClickActionAlt(event.currentTarget, self.featureFlagsClickActionAlt);
                        self.featureFlagsClickActionAlt = null;
                    });
                } else {
                    logService.log('videoroomCtrl - feature-flags-request no videos shown, so ignoring ' + data.type);
                }
            } else if (data.type == 'do-ice-restart-audio') {
                self.onDoIceRestartAudio();
            } else if (data.type == 'audio-mute-unmute') {
                self.onDoAudioMuteUnmute();
            } else if (data.type == 'do-reconnect-mtg') {
                self.onDoReconnectMTG();
            } else if (data.type == 'do-reconnect-mtg-10s') {
                self.onDoReconnectMTG(10);
            } else if (data.type == 'do-reconnect-mtg-20s') {
                self.onDoReconnectMTG(20);
            } else if (data.type == 'do-reconnect-mtg-40s') {
                self.onDoReconnectMTG(40);
            } else if (data.type == 'do-reconnect-sip') {
                self.onDoReconnectSIP();
            } else if (data.type == 'do-reconnect-ws') {
                self.onDoReconnectWS();
            } else if (data.type == 'set-logging-audiojb-mine') {
                self.onSetLoggingAudiojb();
            } else if (data.type == 'set-logging-audio-record-all') {
                self.onRecordAudioAll();
            } else if (data.type == 'trigger-cpu-metrics-30') {
                self.onTriggerCpuMetrics(30);
            } else if (data.type == 'trigger-cpu-metrics-60') {
                self.onTriggerCpuMetrics(60);
            } else if (data.type == 'trigger-cpu-metrics-80') {
                self.onTriggerCpuMetrics(80);
            } else if (data.type == 'trigger-cpu-metrics-reset') {
                self.onResetCpuMetrics();
            } else if (data.type == 'showhide-remote-videos') {
                self.onShowHideRemoteVideos(false);
            } else if (data.type == 'showhide-remote-content') {
                self.onShowHideRemoteVideos(true);
            } else if (data.type == 'show-layout-allhands') {
                self.onLayoutPageShowLayout('allhands');
            } else if (data.type == 'show-layout-spotlight') {
                self.onLayoutPageShowLayout('spotlight');
            } else if (data.type == 'show-layout-grid') {
                self.onLayoutPageShowLayout('gallery');
            } else if (data.type == 'test-layout-add-one') {
                self.onTestLayoutAddVideoRandom(1);
            } else if (data.type == 'test-layout-add-five') {
                self.onTestLayoutAddVideoRandom(5);
            } else if (data.type == 'test-layout-remove-one') {
                self.onTestLayoutRemoveVideoRandom(1);
            } else if (data.type == 'test-layout-remove-five') {
                self.onTestLayoutRemoveVideoRandom(5);
            } else if (data.type == 'test-layout-toggle-self') {
                self.onTestLayoutToggleSelf();
            } else if (data.type == 'test-layout-toggle-content') {
                self.onTestLayoutToggleContent();
            } else if (data.type == 'goto-layout-page-previous') {
                self.onLayoutPageGoto('previous');
            } else if (data.type == 'goto-layout-page-next') {
                self.onLayoutPageGoto('next');
            } else if (data.type == 'set-layout-page-xsmall') {
                self.onLayoutPageSet('xsmall');
            } else if (data.type == 'set-layout-page-small') {
                self.onLayoutPageSet('small');
            } else if (data.type == 'set-layout-page-medium') {
                self.onLayoutPageSet('medium');
            } else if (data.type == 'set-layout-page-large') {
                self.onLayoutPageSet('large');
            } else if (data.type == 'set-layout-page-xlarge') {
                self.onLayoutPageSet('xlarge');
            } else if (data.type == 'layout-page-flip-random') {
                self.onLayoutPageFlip('random');
            } else if (data.type == 'layout-page-flip-toggle') {
                self.onLayoutPageToggleFlip();
            } else if (data.type == 'layout-page-toggle-talker') {
                self.onLayoutPageToggleTalker();
            } else if (data.type == 'copy-notes-html') {
                self.onCopyNotesToClipboard(true);
            } else if (data.type == 'copy-notes-text') {
                self.onCopyNotesToClipboard();
            } else if (data.type == 'trigger-quality-bars') {
                self.triggerQualityBars(data);
            } else if (data.type == 'trigger-app-background') {
                self.onVisibilityChange(null, true);
            } else if (data.type == 'trigger-app-foreground') {
                self.onVisibilityChange(null, false);
            } else {
                logger.warn('onFeatureFlagsRequestInternal', 'feature-flags-request not implemented', data.type);
            }
        }

        function onFeatureFlagsClickAction(div, is_screen) {
            var user =
                (div && div.getAttribute('user')) ||
                (is_screen && '' + self.getScreenshareIdFromAttendantId(self.attendantId));

            $window.$('#videoroom-videos').removeAttr('has-click-action');
            $window.$('#localSfuScreenShareFeedContainer').removeAttr('has-click-action');
            $window.$('#localSfuScreenShareFeedContainer').unbind('click');

            var action = self.featureFlagsClickAction;
            self.featureFlagsClickAction = null;

            self.msgflowEvent('feature click', { type: action, id: user });

            if (!user) {
                logger.warn(
                    'onFeatureFlagsClickAction',
                    'ignoring feature-flags-click-action div=' + !!div + ' is_screen=' + !!is_screen
                );
                return;
            }

            self.onFeatureFlagsRequestInternalAlt(action, user, div);
        }

        function onFeatureFlagsRequestInternalAlt(action, user, div) {
            if (action == 'do-ice-restart') {
                self.onDoIceRestart(user);
            } else if (action == 'request-keyframe') {
                self.onRequestKeyFrame(user);
            } else if (action == 'select-substream' && div) {
                self.onSelectSubstream(user, div);
            } else if (action == 'restart-video-play') {
                self.onRestartVideoPlay(user);
            } else if (action == 'restart-video-publish') {
                self.onRestartVideoPublish(user);
            } else if (action == 'showhide-one-video' && div) {
                self.onShowHideOneVideo(user, div);
            } else if (action == 'toggle-spotlight-in-record') {
                self.onToggleSpotlightInRecord(user);
            } else if (action == 'toggle-layout-pin') {
                self.onToggleLayoutPin(user);
            } else if (action == 'layout-page-flip-selected') {
                self.onLayoutPageFlip(user);
            } else if (action == 'test-layout-remove-selected') {
                self.onTestLayoutRemoveVideo(user);
            } else if (action == 'do-reconnect-sip-other') {
                // alt
                self.onDoReconnectOtherSIP(user);
            } else if (action == 'do-reconnect-ws-other') {
                self.onDoReconnectOtherWS(user);
            } else if (action == 'set-logging-audiojb-other') {
                self.onSetLoggingAudiojb(user);
            } else {
                logger.warn(
                    'onFeatureFlagsRequestInternalAlt',
                    'unimplemented feature-flags-request ' + action + ' or needs div not supplied'
                );
            }
        }

        function onFeatureFlagsClickActionAlt(li, action) {
            var user = (li && li.id && li.id.substring('attendee-'.length)) || null;

            self.msgflowEvent('feature click', { type: action, id: user });

            if (!user) {
                logger.warn(
                    'onFeatureFlagsClickActionAlt',
                    'ignoring feature-flags-click-action-alt li=' + !!li + ' action=' + action
                );
                return;
            }

            self.onFeatureFlagsRequestInternalAlt(action, user);
        }

        // show resize layout user interface.
        function onStartResizeLayout() {
            logService.log('videoroomCtrl - start-resize-layout, has maxvideo=' + !!self.maxvideo);
            if (self.maxvideo && (self.layoutLock != 'locked' || self.isHost)) {
                var div0 = $window.$('#videoroom-videos > div[spotlight="true"]:not(.audioonly)').get(0);
                if (div0) {
                    var w0 = div0.offsetWidth,
                        y0 = div0.offsetTop;
                    var div = document.createElement('div');
                    var div1 = document.createElement('div');
                    div.className = 'layout-resize-overlay';
                    div1.className = 'layout-resize-divider';
                    var axis;
                    if (y0 > 10) {
                        div1.style.left = '0px';
                        div1.style.right = '0px';
                        div1.style.top = y0 - 6 + 'px';
                        div1.style.height = '4px';
                        div1.style.cursor = 'row-resize';
                        axis = 'y';
                    } else {
                        div1.style.left = w0 - 6 + 'px';
                        div1.style.width = '4px';
                        div1.style.top = '0px';
                        div1.style.bottom = '0px';
                        div1.style.cursor = 'col-resize';
                        axis = 'x';
                    }
                    div.appendChild(div1);
                    var reset = document.createElement('button');
                    reset.className = 'layout-resize-close';
                    reset.innerText = 'Reset';
                    div.appendChild(reset);
                    var close = document.createElement('button');
                    close.className = 'layout-resize-close';
                    close.innerText = 'DONE';
                    div.appendChild(close);

                    $window.$('#videoroom').append(div); // do not make a copy
                    var timer = null;

                    $window.$(div1).draggable({
                        axis: axis,
                        stop: function (event, ui) {},
                        drag: function (event, ui) {
                            // use console.info to avoid log entries, but display locally for debugging.
                            console.info(ui.position);
                            var fraction =
                                axis == 'x'
                                    ? (div.offsetWidth - ui.position.left - 4) / div.offsetWidth
                                    : (ui.position.top + 2) / div.offsetHeight;
                            if (fraction < 0.05) {
                                event.preventDefault();
                                event.stopImmediatePropagation();
                                fraction = 0;
                                if (axis == 'x') {
                                    div1.style.left = div.offsetWidth - 12 + 'px';
                                } else {
                                    div1.style.top = '0px';
                                }
                            } else if (fraction >= 0.75) {
                                event.preventDefault();
                                event.stopImmediatePropagation();
                                return;
                            }

                            videoLayoutAlgorithmService.setCurrentResizeData({
                                is_wide: axis == 'x',
                                fraction: fraction
                            });
                            if (timer) {
                                $timeout.cancel(timer);
                                timer = null;
                            }
                            timer = $timeout(function () {
                                timer = null;
                                self.updateVideosLayout();
                            }, 200);
                        }
                    });

                    reset.onclick = function (event) {
                        videoLayoutAlgorithmService.clearCurrentResizeData();
                        if (timer) {
                            $timeout.cancel(timer);
                            timer = null;
                        }
                        self.updateVideosLayout();

                        $timeout(function () {
                            var w0 = div0.offsetWidth,
                                y0 = div0.offsetTop;
                            if (y0 > 10) {
                                div1.style.left = '0px';
                                div1.style.right = '0px';
                                div1.style.width = 'auto';
                                div1.style.top = y0 - 6 + 'px';
                                div1.style.height = '4px';
                                div1.style.bottom = 'auto';
                                div1.style.cursor = 'row-resize';
                                axis = 'y';
                            } else {
                                div1.style.left = w0 - 6 + 'px';
                                div1.style.width = '4px';
                                div1.style.right = 'auto';
                                div1.style.top = '0px';
                                div1.style.bottom = '0px';
                                div1.style.height = 'auto';
                                div1.style.cursor = 'col-resize';
                                axis = 'x';
                            }
                        }, 400);
                    };

                    close.onclick = function (event) {
                        try {
                            $window.$(div1).draggable('destroy');
                        } catch (e) {}
                        $window.$(div).remove();
                        if (timer) {
                            $timeout.cancel(timer);
                            timer = null;
                        }
                        self.updateVideosLayout();
                    };
                }
            }
        }

        // when server reflected self video is to be shown - show-video-from-sfu.
        function onShowVideoFromSfu() {
            logService.log('videoroomCtrl - onShowVideoFromSfu testvideos=' + !!self.testvideos);
            if (!self.testvideos) {
                self.testvideos = {
                    count: 1,
                    calls: 0,
                    plugins: [],
                    interval: 0
                };
                if (self.videoroom) {
                    self.testvideosStartPublish();
                }
            } else {
                self.testvideosStopPublish();
                self.testvideos = null;
            }
        }

        // when server recording video is to be shown - show-video-from-mcu.
        function onShowVideoFromMcu() {
            logService.log('videoroomCtrl - onShowVideoFromMcu videoFromMcu=' + !!self.videoFromMcu);
            if (!self.videoFromMcu) {
                var div = self.createVideoElement(true, null, self.attendantId + ':Record', undefined, undefined, true);
                var video = (self.videoFromMcu = div.querySelector('video'));
                video.muted = true;
            } else {
                var div1 = self.videoFromMcu.parentNode;
                self.removeVideoElement(undefined, div1);
                self.videoFromMcu = null;
            }
            self.msgflowEvent('peer-connection:mcu', { type: 'audio', reason: 'MCU video toggled' });
            self.createOfferForSIP(false, false, 'mcu-video');
        }

        // when ICE restart is requested - do-ice-restart
        function onDoIceRestart(id) {
            logService.log('videoroomCtrl - onDoIceRestart ' + id);
            var plugin = null;
            var type = null;
            if (!id || id == self.attendantId) {
                type = 'video-send';
                plugin = self.videoroom;
            } else if (self.feeds[id]) {
                type = 'video-receive';
                plugin = self.feeds[id];
            }
            if (plugin && plugin.state && plugin.state.ice != 'disconnected') {
                plugin.state.ice = 'disconnected'; // do that iceRestartAfter complete
                self.iceRestartAfter(plugin, type, type == 'video-receive' ? id : undefined, 300);
            }
        }

        // when ICE restart requested for audio only
        function onDoIceRestartAudio() {
            logService.log('videoroomCtrl - onDoIceRestartAudio');
            var plugin = self.sipcall;
            var type = 'audio';
            if (plugin && plugin.state && plugin.state.ice != 'disconnected') {
                plugin.state.ice = 'disconnected'; // do that iceRestartAfter complete
                self.iceRestartAfter(plugin, type, undefined, 300);
            }
        }

        // when audio mute-unmute should be done.
        function onDoAudioMuteUnmute() {
            if (
                self.sipcall &&
                !attendeeService.getIsAudioMuted() &&
                !connectivityService.getAudioThroughPhone() &&
                !connectivityService.getIsPhoneOnly()
            ) {
                logService.log('videoroomCtrl - onDoAudioMuteUnmute - toggle twice');
                attendeeService.toggleAudio();
                $timeout(function () {
                    attendeeService.toggleAudio();
                }, 200);
            } else {
                logService.log('videoroomCtrl - onDoAudioMuteUnmute - ignored');
            }
        }

        // when reconnect sip should be done.
        // TODO: this feature should be removed soon.
        function onDoReconnectSIP() {
            if (self.sipcall) {
                $timeout(function () {
                    // use timer to avoid sync issues with caller.
                    self.doHangup(); // this will trigger a reconnect.
                }, 200);
            }
        }

        // when reconnect ws should be done.
        // TODO: this feature should be removed soon.
        function onDoReconnectWS() {
            if (self.janus) {
                $timeout(function () {
                    $window.Janus.ws.close(); // this will trigger a reconnect.
                }, 200);
            }
        }

        // when reconnect MTG should be done.
        // TODO: this feature should be removed soon.
        function onDoReconnectMTG(delay) {
            $timeout(function () {
                socketService.closeSocketForTesting(delay ? delay * 1000 : delay);
            }, 200);
        }

        // when reconnect sip on other should be done.
        function onDoReconnectOtherSIP(id) {
            socketService.send({
                message: 'attendee-message',
                data: { type: 'reconnect-sip', to: parseInt(id) }
            });
        }

        // when reconnect ws on other should be done.
        function onDoReconnectOtherWS(id) {
            socketService.send({
                message: 'attendee-message',
                data: { type: 'reconnect-ws', to: parseInt(id) }
            });
        }

        // when attendee-message for force-audio-muted is received
        function onForceAudioMuted(from) {
            var version = helperService.isMobileRedirectByPass() ? false : helperService.getChromeVersion();
            logService.log(
                'videoroomCtrl - force-audio-muted received from ' +
                    from +
                    ' version=' +
                    version +
                    ' reconnectOnMute=' +
                    self.reconnectOnMute
            );
            if (self.reconnectOnMute && version <= 84) {
                self.onDoReconnectWS();
            }
        }

        // when attendee-message for force-video-muted is received. only allowed from host.
        function onForceVideoMuted(from, screen) {
            var host = attendeeListService.getHost();

            if (host && host.attendantId == from) {
                if (!screen && !attendeeService.getIsVideoMuted()) {
                    logService.log('videoroomCtrl - force-video-muted received from host=' + from);
                    attendeeService.toggleVideo();
                    notificationService.show(
                        localizationService.translate('DIALOG.HOST_TURNED_OFF_YOUR_WEBCAM'),
                        'danger'
                    );
                } else if (screen && self.isScreenVideo) {
                    logService.log('videoroomCtrl - force-video-muted (screen) received from host=' + from);
                    $rootScope.$broadcast('stop-sfu-screenshare');
                    notificationService.show(
                        localizationService.translate('DIALOG.HOST_TURNED_OFF_YOUR_SCREENSHARE'),
                        'danger'
                    );
                } else {
                    logService.log(
                        'videoroomCtrl - force-video-muted received from host ' +
                            from +
                            ' screen=' +
                            screen +
                            ', already muted'
                    );
                }
            } else {
                logService.log('videoroomCtrl - force-video-muted received from non-host ' + from + ', ignored');
            }
        }

        // when set-logging-audiojb-mine or set-logging-audiojb-other is triggered.

        function onSetLoggingAudiojb(user) {
            logService.log('videoroomCtrl - set-logging-audiojb-* user=' + user);
            if (!user) {
                user = self.attendantId;
            }
            self.loggingAudioJb[user] = !self.loggingAudioJb[user];
            var data = { value: self.loggingAudioJb[user], attendantId: user };
            socketService.send({ message: 'sfu-set-audio-diagnostics', data: data });
        }

        function onRecordAudioAll(user) {
            logger.log('videoroomCtrl - set-logging-audio-record-* user=' + user);
            const linkParent = $("a[data='set-logging-audio-record-all']").parent();
            $("a[data='set-logging-audio-record-all']").hide();
            let textNode = linkParent.contents().filter(function () {
                return this.nodeType == 3;
            });

            const originalText = textNode.text();
            textNode.replaceWith('Recording of all attendees for 60s in progress...');

            audioRecordTimer = setTimeout(() => {
                audioRecordTimer = null;
                textNode = linkParent.contents().filter(function () {
                    return this.nodeType == 3;
                });
                textNode.replaceWith(originalText);
                $("a[data='set-logging-audio-record-all']").show();
            }, 60000);

            socketService.send({ message: 'sfu-debug-audio-recording' });
        }

        function onMeetingStateV2(e, options) {
            switch (options.state) {
                case 'ending':
                    clearTimeout(audioRecordTimer);
                    audioRecordTimer = null;
            }
        }

        // when key frame is requested - request-keyframe
        function onRequestKeyFrame(id) {
            logService.log('videoroomCtrl - onRequestKeyFrame ' + id);
            if (!id || id == self.attendantId || (self.feeds[id] && self.feeds[id] !== true)) {
                self.requestKeyFrame(id);
            }
        }

        // when select substream is desired
        function onSelectSubstream(id, div) {
            logService.log('videoroomCtrl - onSelectSubstream ' + id);
            var match = (div.getAttribute('simulcast') || '').match(/^(\d+),(\d+)$/);
            if (match) {
                self.simulcastReason = 'onSelectSubstream featureFlags selected';
                self.setSimulcast(div, parseInt(match[1]), parseInt(match[2]), true);
            }
        }

        // when restart of video play is desired
        function onRestartVideoPlay(id) {
            logService.log('videoroomCtrl - onRestartVideoPlay ' + id);
            if (id && id != self.attendantId) {
                self.msgflowEvent('play-restart:labs', { reason: 'on restart-video-play action', id: id });
                self.restartVideoPlay(id);
            }
        }

        // when restart of video publish is desired. is_screen is only valid for local video.
        function onRestartVideoPublish(id, is_screen) {
            if (!id || id == self.attendantId) {
                // local video
                if (!is_screen) {
                    logService.log(
                        'videoroomCtrl - onRestartVideoPublish for local video, republishing=' +
                            self.republishing +
                            ' videoroom=' +
                            !!self.videoroom
                    );
                    if (!self.republishing && self.videoroom) {
                        self.republishing = true;
                        self.stopVideoPublish();
                        self.startVideoPublish();
                    }
                } else {
                    logService.log(
                        'videoroomCtrl - onRestartVideoPublish for local screen, state=' +
                            self.screenshareState +
                            ' screenshare=' +
                            !!self.screenshare
                    );
                    if (self.screenshare && self.screenshareState != 'disconnected') {
                        self.saveScreenshareForReconnection();
                        self.stopScreenShare(false, 'from labs');
                        self.startScreenShare();
                    }
                }
            } else {
                // remote video
                is_screen = false;
                if (self.isScreenshareId(id)) {
                    is_screen = true;
                    id = self.getAttendantIdFromScreenshareId(id);
                }
                if (id == self.attendantId) {
                    self.onRestartVideoPublish(id, is_screen);
                } else {
                    var data = { type: 'restart-video-publish', screen: is_screen, to: parseInt(id) };
                    socketService.send({
                        message: 'attendee-message',
                        data: data
                    });
                }
            }
        }

        function onToggleSpotlightInRecord(id) {
            var data;
            if (self.isScreenshareId(id)) {
                var attendee = self.findAttendee(self.getAttendantIdFromScreenshareId(id, true));
                if (attendee) {
                    data = { id: 'screen-' + attendee.email };
                } else {
                    logger.warn(
                        'onToggleSpotlightInRecord',
                        'failed to toggle-spotlight-in-record, cannot find attendee for ' + id
                    );
                }
            } else {
                data = { id: id };
            }
            socketService.send({ message: 'sfu-toggle-spotlight', data: data });
        }

        function onCopyNotesToClipboard(isHtml) {
            if ($window.$('#note-firepad').hasClass('ng-hide')) {
                notificationService.show('Please open notes first', 'danger');
                return;
            }

            if (isHtml) {
                var w = window.open('', '_blank');
                var style =
                    '.CodeMirror { font-family: sans-serif; font-size: 14px; height: auto; }\n' +
                    ['black', 'red', 'blue', 'green', 'yellow', 'cyan', 'magenta', 'grey'].map(function (color) {
                        return '.firepad-c-' + color + ' { color: ' + color + ' }';
                    });

                var head = $window
                    .$('head link[href*="codemirror"], head link[href*="firepad"]')
                    .map(function () {
                        return this.outerHTML.replace(/\shref="/, ' href="' + $window.location.origin + '/');
                    })
                    .get()
                    .join('\n');
                var body =
                    '<div class="CodeMirror">' +
                    $window
                        .$('.CodeMirror .CodeMirror-code')
                        .html()
                        .replace(/<input\s/g, '<input disabled ') +
                    '</div>';

                var name = $window.$('.marquee-title').text();
                var title = meetingService.getMeetingCode();
                var env = helperService.getEnvironment();
                if (env != 'prod') {
                    title += ',' + env;
                }

                w.document.write(
                    '<head><title>' +
                        title +
                        '</title>' +
                        head +
                        '<style type="text/css">' +
                        style +
                        '</style></head><body><h1>' +
                        name +
                        ' (' +
                        title +
                        ')</h1>' +
                        body +
                        '</body>'
                );
            } else {
                // do not use text(), as it removes new lines and other special characters.
                var text = ($window.$('.CodeMirror')[0] || {}).innerText;
                var options = {
                    successCallback: function () {
                        notificationService.show('Copied to clipboard', 'success');
                    },
                    errorCallback: function () {
                        notificationService.show('Failed to copy', 'danger');
                    }
                };
                // do not use logService for privacy.
                console.info('copying\n' + text);
                $rootScope.$broadcast('copy-text-to-clipboard', { text: text, options: options });
            }
        }
    }
]);
